<template>
  <div class="dropdown export-menu">
    <button
      class="btn btn-sm btn-outline-secondary dropdown-toggle"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :disabled="!!loadingFormat"
    >
      <span v-if="loadingFormat" class="spinner-border spinner-border-sm me-2"></span>
      <i v-else class="fas fa-download me-2"></i>
      {{ $t('flexigo.common.export') || 'Export' }}
    </button>
    <ul class="dropdown-menu">
      <li v-if="showFormat('png')">
        <a class="dropdown-item" href="#" @click.prevent="handleExport('png')">
          <i class="fas fa-image me-2"></i>PNG
        </a>
      </li>
      <li v-if="showFormat('pdf')">
        <a class="dropdown-item" href="#" @click.prevent="handleExport('pdf')">
          <i class="fas fa-file-pdf me-2"></i>PDF
        </a>
      </li>
      <li v-if="showFormat('print')">
        <a class="dropdown-item" href="#" @click.prevent="handleExport('print')">
          <i class="fas fa-print me-2"></i>{{ $t('flexigo.common.print') || 'Print' }}
        </a>
      </li>
      <li v-if="showFormat('csv')">
        <a class="dropdown-item" href="#" @click.prevent="handleExport('csv')">
          <i class="fas fa-file-csv me-2"></i>CSV
        </a>
      </li>
      <li v-if="showFormat('excel')">
        <a class="dropdown-item" href="#" @click.prevent="handleExport('excel')">
          <i class="fas fa-file-excel me-2"></i>Excel
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ExportMenu',
  props: {
    /**
     * Which export formats to show. Defaults to the legacy formats (png, csv, excel).
     * Pass an explicit array to add or limit formats (e.g. ridership adds pdf/print).
     */
    formats: {
      type: Array,
      default: () => ['png', 'csv', 'excel'],
    },
    /**
     * Format currently being exported. When it matches a menu item,
     * that item shows a spinner instead of its icon and is disabled.
     */
    loadingFormat: {
      type: String,
      default: '',
    },
  },
  methods: {
    showFormat(fmt) {
      return this.formats.includes(fmt);
    },
    handleExport(format) {
      // Close the dropdown before emitting so the spinner on the
      // toggle button is visible instead of being covered by the menu.
      const { Dropdown } = window.bootstrap || {};
      const inst = Dropdown?.getInstance(this.$el.querySelector('.dropdown-toggle'));
      if (inst) inst.hide();
      else this.$el.querySelector('.dropdown-menu.show')?.classList.remove('show');
      this.$emit('export', format);
    },
  },
};
</script>

<style scoped>
/* Positioning handled by parent */
</style>
